module.exports = __webpack_public_path__ + "static/media/JURIDICO.91bb2c42.png";